import * as layout from '../../components/markLayout.module.css';
import Table, { TableColumn } from '@hero/ui-kit/tables/Table';
import React from 'react';
import P from '@hero/ui-kit/typography/P';
import { formatDateTime, normalizeDateString } from '@hero/hero-utils/date';
import type { ActiveDrip } from '../../types';
type Props = {
    drips: ActiveDrip[];
};
const columns: TableColumn<ActiveDrip>[] = [
    {
        colKey: 'drip_name',
        name: 'Drip Name',
        align: 'left',
        headAlign: 'left',
        render: (d) => (
            <P noDefaultMargin strong>
                {d.drip_name}
            </P>
        )
    },
    {
        colKey: 'current_step',
        name: 'Current Step',
        align: 'left',
        headAlign: 'left',
        render: (d) => <P noDefaultMargin>{d.current_step}</P>
    },
    {
        colKey: 'enrolled_at',
        name: 'Enrolled At',
        align: 'left',
        headAlign: 'left',
        render: (d) => <P noDefaultMargin>{formatDateTime(normalizeDateString(d.enrolled_at))}</P>
    },
    {
        colKey: 'version',
        name: 'Version',
        align: 'left',
        headAlign: 'left',
        render: (d) => <P noDefaultMargin>v{d.version_number}</P>
    },
    {
        colKey: 'variant',
        name: 'Variant',
        align: 'left',
        headAlign: 'left',
        render: (d) => <P noDefaultMargin>{d.variant || '—'}</P>
    }
];
const ActiveDripsList: React.FC<Props> = ({ drips }) => {
    if (drips.length === 0) {
        return <P noDefaultMargin>No active drips.</P>;
    }
    return (
        <div
            style={{
                overflowX: 'auto'
            }}
            className={layout.tableScroll}
        >
            <Table columns={columns} data={drips} rowKey="drip_instance_id" emptyValues="—" />
        </div>
    );
};
export default ActiveDripsList;
